import placeioMarkUrl from '../../../docs/brand/reference/placeio-mark.svg';
import { MapSurface } from '../../map/MapSurface';
import { DEFAULT_BASEMAP_CONFIGURATION, type BasemapConfiguration } from '../../basemaps/catalog';

const LANDING_VIEW = { center: [151.21, -33.86] as const, zoom: 10, bearing: 0, pitch: 0 };
const EMPTY_ITEMS: readonly never[] = [];
const IGNORE_VIEW = () => undefined;
// Landing presentation only: project defaults and normal label choices stay untouched.
const LANDING_BASEMAP: BasemapConfiguration = {
  ...DEFAULT_BASEMAP_CONFIGURATION,
  presetId: 'dropmap-light',
  customizationByPreset: {
    ...DEFAULT_BASEMAP_CONFIGURATION.customizationByPreset,
    'dropmap-light': {
      ...DEFAULT_BASEMAP_CONFIGURATION.customizationByPreset['dropmap-light'],
      labelsOpacity: 0,
    },
  },
};

export function AppStartScreen() {
  return (
    <main className="app-start-screen">
      <div className="start-background-map">
        <MapSurface
          interactive={false}
          basemap={LANDING_BASEMAP}
          backgroundColour="#f8faf9"
          view={LANDING_VIEW}
          sources={EMPTY_ITEMS}
          layers={EMPTY_ITEMS}
          onViewChange={IGNORE_VIEW}
        />
      </div>
      <section className="app-start-content" aria-labelledby="app-start-heading">
        <div className="start-mark" aria-hidden="true">
          <img alt="" className="start-brand-mark" src={placeioMarkUrl} />
        </div>
        <h1 id="app-start-heading">Start a new map</h1>
        <p className="start-intro">
          Import CSV, Excel (.xlsx), GeoJSON, zipped Shapefiles, GeoPackages and KML/KMZ.
        </p>
        <div data-import-actions="start" />
        <p className="privacy-note">Your spatial data stays in this browser during normal use.</p>
      </section>
    </main>
  );
}
